export interface Recipient {
    isInternal?: boolean;
    email?: string;
}
type RecipientKey = keyof Recipient;

export const RecipientKeys: RecipientKey[] = ['isInternal', 'email'];
